import React from "react";
import I18n from "i18n-js";
import { bool, func, string } from "prop-types";
import Modal from "../../common/components/elements/Modal";

const DeleteModalConfirmation = ({ isOpen, onClose, uuidToDelete, deleteCertificate }) => {
  if (!isOpen) {
    return null;
  }

  const onDelete = () => {
    if (uuidToDelete) {
      deleteCertificate(uuidToDelete);
      onClose();
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      title={I18n.t("pages.clients.certificates.delete.title")}
      onClose={onClose}
    >
      <h2 className="text-center">
        {I18n.t("pages.clients.certificates.delete.title")}
      </h2>
      <p>{I18n.t("pages.clients.certificates.delete.content")}</p>
      <div className="d-flex justify-content-between">
        <button className="btn btn-secondary" onClick={onClose}>
          {I18n.t("common.cancel")}
        </button>
        <button className="btn btn-danger" onClick={onDelete}>
          {I18n.t("pages.clients.certificates.delete.confirmation")}
        </button>
      </div>
    </Modal>
  );
};

DeleteModalConfirmation.propTypes = {
  isOpen: bool.isRequired,
  onClose: func.isRequired,
  uuidToDelete: string,
  deleteCertificate: func.isRequired,
};

export default DeleteModalConfirmation;
